import { ExclamationCircleFilled } from '@ant-design/icons'
import { FC } from 'react'

import Text from '~/core/Text'
import Box from '~/core/Box'
import getColor from '~/lib/getColor'
import Button from '~/core/Button'

interface ConfirmCloseCreateTeamModalPropsType {
    onNo: () => void
    onYes: () => void
}

export const ConfirmCloseCreateTeamModal: FC<
    ConfirmCloseCreateTeamModalPropsType
> = ({ onNo, onYes }) => {
    return (
        <Box direction="col">
            <Box>
                <ExclamationCircleFilled
                    style={{
                        marginRight: '8px',
                        marginTop: '4px',
                        color: getColor('warning'),
                    }}
                />
                <Text color="blackAlpha65">
                    Are you sure you want to cancel? Your workspace has not been
                    created yet.
                </Text>
            </Box>
            <Box marginTop="12px" justifyContent="end">
                <Button onClick={onNo}>No</Button>
                <Button
                    type="primary"
                    onClick={onYes}
                    style={{ marginLeft: '8px' }}
                >
                    Yes
                </Button>
            </Box>
        </Box>
    )
}

export default ConfirmCloseCreateTeamModal
